import { useState, useCallback } from "react"
import Cookies from "js-cookie"

const API = `${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/ltd`

function authHeader() {
    // Auth token lives in the `token` cookie (see billingApi.js / useLogin.js),
    // not localStorage — reading localStorage sent no auth header on prod.
    const t = Cookies.get("token")
    return t ? { Authorization: `Bearer ${t}` } : {}
}

function h() {
    return { ...authHeader(), "Content-Type": "application/json" }
}

export function useLtd() {
    const [status, setStatus] = useState(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)

    const fetchStatus = useCallback(async () => {
        setLoading(true)
        setError(null)
        try {
            const res = await fetch(`${API}/status`, { headers: h() })
            const data = await res.json()
            if (!res.ok) throw new Error(data.error || "Failed to load LTD status")
            setStatus(data)
            return data
        } catch (e) {
            setError(e.message)
            return null
        } finally {
            setLoading(false)
        }
    }, [])

    const validateCodes = useCallback(async (codes) => {
        const res = await fetch(`${API}/validate`, {
            method: "POST",
            headers: h(),
            body: JSON.stringify({ codes })
        })
        const data = await res.json()
        if (!res.ok) throw new Error(data.error || "Validation failed")
        return data
    }, [])

    const redeemCodes = useCallback(async (codes, turnstileToken) => {
        const res = await fetch(`${API}/redeem`, {
            method: "POST",
            headers: h(),
            body: JSON.stringify({ codes, turnstile_token: turnstileToken })
        })
        const data = await res.json()
        if (!res.ok) throw new Error(data.error || "Redemption failed")
        if (data.success) await fetchStatus()
        return data
    }, [fetchStatus])

    return { status, loading, error, fetchStatus, validateCodes, redeemCodes }
}
